import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickHistoryFeatureEngineering from '@/components/brick_history_feature_engineering.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-circle', 'text-orange']
infos.front_classes = ['fas', 'fa-history', 'text-white']
infos.name = 'historyfe'
infos.associated_class_name = 'AutomlHistoryFeatureEngineeredTable'
infos.editing_component_name = 'BrickHistoryFeatureEngineering'
infos.editing_component = BrickHistoryFeatureEngineering
infos.descriptions = {
	en: {
		short_tooltip_description: 'History Feature Engineering',
		full_tooltip_description:
			'Automatic creation of history feature engineered columns for a table',
		navbar_name: 'History FE',
	},
	fr: {
		short_tooltip_description: "FE sur l'historique",
		full_tooltip_description:
			"Feature Engineering sur l'historique d'une table",
		navbar_name: 'Historique FE',
	},
}
// infos.short_tooltip_description = 'historyfe_short_tooltip'
// infos.full_tooltip_description = 'historyfe_full_tooltip'
// infos.navbar_name = 'historyfe_navbar'
infos.background_color = 'orange'

brick_registerer(infos)
